import "prismjs";
import "./prism-mata";
import "./prism-java";
import "./prism-python";
import "prismjs/components/prism-stata";
